import gql from 'graphql-tag'
import { PRODUCT_ESTIMATED_DELIVERY_FRAGMENT } from '~/graphql/gql/product/fragments/productEstimatedDeliveryFragment'
import { PRODUCT_MAIN_VARIANT_BASE_FRAGMENT } from '~/graphql/gql/product/fragments/productMainVariantBaseFragment'
import { PRODUCT_AVAILABILITY_FRAGMENT } from '~/graphql/gql/product/fragments/productAvailabilityFragment'

export const PRODUCT_FOR_LIST_FRAGMENT = gql`
  fragment productForList on Product {
    id
    productTypeId
    brief
    title
    mainVariant {
      ...mainVariant
      estimatedDeliveries(type: $estimatedDeliveryType) {
        ...productEstimatedDeliveryFragment
      }
      marketplace {
        deliveryDelay
        isMarketplace
      }
      variantStickers(useCase: LIST) {
        isStock
        name
        text
        date
      }
      freeDelivery
      availability {
        ...productAvailabilityFragment
      }
      marketplaceType
      parameters {
        key
        value
        paramValueId
      }
    }
    urlKey
    isAdultOnly
    mainCategoryUrlKey
    mainMenuUrlKey
    marketplace {
      marketplacePartnerTitle
      marketplacePartnerUrl
    }
    rank {
      rank
      count
    }
    variantParameters {
      name
      label
      items {
        id
        imageId
        label
        colorId
        variantIds
        variantUrls {
          url
        }
        urlKey
      }
    }
    energyLabel {
      label
      class
    }
    identicalProductIds
    lowestProductPrice
  }

  ${PRODUCT_ESTIMATED_DELIVERY_FRAGMENT}
  ${PRODUCT_AVAILABILITY_FRAGMENT}
  ${PRODUCT_MAIN_VARIANT_BASE_FRAGMENT}
`
